export const GET_QR_SCAN_STATUS_LOAD = 'qrCode/GET_QR_SCAN_STATUS_LOAD';
export const GET_QR_SCAN_STATUS_SUCCESS = 'qrCode/GET_QR_SCAN_STATUS_SUCCESS';
export const GET_QR_SCAN_STATUS_FAIL = 'qrCode/GET_QR_SCAN_STATUS_FAIL';
export const GET_QR_CODE_LOAD = 'qrCode/GET_QR_CODE_LOAD';
export const GET_QR_CODE_SUCCESS = 'qrCode/GET_QR_CODE_SUCCESS';
export const GET_QR_CODE_FAIL = 'qrCode/GET_QR_CODE_FAIL';
